import type { PosVoucher } from './api';
import type { SaleCoupon } from './cart-store';

/**
 * What a code typed (or scanned) into the till's code box turns into.
 *
 * A gift check is tried first: it is the buyer's own and is checked against
 * them on the spot, so a wrong owner, a used one or an expired one says so
 * straight away. Only a code that is no gift check at all (`voucher_invalid`)
 * falls through to an ordinary discount code, and only when the tenant has
 * till codes; that one is priced, and refused if need be, by the preview.
 */
export async function resolveTypedCode(args: {
  code: string;
  vouchersEnabled: boolean;
  codesEnabled: boolean;
  lookupVoucher: (code: string) => Promise<PosVoucher>;
}): Promise<{ coupon: SaleCoupon } | { error: string }> {
  const code = args.code.trim().toUpperCase();
  if (!code) return { error: 'coupon_invalid' };
  if (args.vouchersEnabled) {
    try {
      const v = await args.lookupVoucher(code);
      return { coupon: { kind: 'voucher', id: v.id, code: v.code, name: v.programName } };
    } catch (err) {
      const reason =
        (err as { response?: { data?: { error?: string } } } | null)?.response?.data?.error ??
        'voucher_lookup_failed';
      if (reason !== 'voucher_invalid' || !args.codesEnabled) return { error: reason };
    }
  }
  if (!args.codesEnabled) return { error: 'coupon_invalid' };
  return { coupon: { kind: 'code', code } };
}
